import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import DetailedProfile from '../../components/DetailedProfile';
import UserActivity from '../../components/UserActivity';
import styles from './ProfilePage.module.css';

import {
  useGetProfileQuery,
  useGetUserProfileQuery,
} from '../../store/api/profileApi';

import { useAuth } from '../../hooks/useAuth';

export default function ProfilePage() {
  const { userId } = useParams();
  const { userId: loggedInUserId } = useAuth();

  const isMyProfile = !userId || userId === loggedInUserId;

  // Always call hooks - fetch own profile
  const {
    data: myProfile,
    isLoading: myLoading,
    isError: myError,
  } = useGetProfileQuery(undefined, { skip: !isMyProfile });

  // Fetch other user's profile
  const {
    data: otherProfile,
    isLoading: otherLoading,
    isError: otherError,
  } = useGetUserProfileQuery(userId, {
    skip: isMyProfile || !userId,
  });

  const user = isMyProfile ? myProfile : otherProfile;
  const isLoading = myLoading || otherLoading;
  const isError = myError || otherError;

  if (isLoading) {
    return (
      <>
        <Header />
        <div className={styles.loadingContainer}>
          <p>Loading profile...</p>
        </div>
      </>
    );
  }

  if (isError || !user) {
    return (
      <>
        <Header />
        <div className={styles.errorContainer}>
          <p>Failed to load profile</p>
        </div>
      </>
    );
  }

  return (
    <div className={styles.container}>
  <Header />

  <div className={styles.content}>
    <aside className={styles.sidebar}>
      <DetailedProfile user={user} isMyProfile={isMyProfile} />
    </aside>

    <main className={styles.main}>
      <UserActivity user={user} isMyProfile={isMyProfile} />
    </main>
  </div>
</div>
  );
}